var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
var SvgFolder = function SvgFolder(props, ref) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 20 15.5",
    ref: ref
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#757b8a",
    d: "M19.773 7.528a1.65 1.65 0 0 0-1.4-.739H5.403a1.65 1.65 0 0 0-1.49.891l-3.43 6.941a1.23 1.23 0 0 0 1.207.888h13.795a1.56 1.56 0 0 0 1.392-.831l2.964-5.735a1.4 1.4 0 0 0-.069-1.415Zm0 0"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#757b8a",
    d: "M3.078 6.874a1.82 1.82 0 0 1 1.658-1.068h13.592V4a1.35 1.35 0 0 0-1.348-1.35H9.055a.04.04 0 0 1-.023-.005L7.614.583A1.35 1.35 0 0 0 6.5 0H1.348A1.35 1.35 0 0 0 0 1.35v12.228Zm0 0"
  })));
};
var ForwardRef = /*#__PURE__*/forwardRef(SvgFolder);
export default ForwardRef;